import { configurationValide } from './config';
import type { RosettaApi } from './rosetta-api';
import { creerApiTahiti } from './tahiti';

export {
  ContexteTravailRequisError,
  IdentifiantsInvalidesError,
  InterruptionIncompleteError,
  NoyauxIndisponiblesError,
  ServiceIndisponibleError,
  SessionExpireeError,
  TraductionIntrouvableError,
} from './erreurs';
export {
  ConfigurationInvalideError,
  chargerConfiguration,
  configurationValide,
} from './config';
export type { ConfigTahiti, ProblemeConfig, ResultatConfig } from './config';
export type { RosettaApi } from './rosetta-api';

let api: RosettaApi | null = null;

/**
 * The client the screens use: the Tahiti one, built once from the public variables
 * (`config.ts`). There is no other implementation in the application. The
 * configuration is checked when the application starts (`main.tsx`), so the
 * `ConfigurationInvalideError` this can raise never reaches a screen in practice.
 */
export function getApi(): RosettaApi {
  api ??= creerApiTahiti(configurationValide());
  return api;
}

/** Replaces the client (tests), or restores the Tahiti one with `null`. */
export function definirApi(remplacant: RosettaApi | null): void {
  api = remplacant;
}
